<template>
  <v-container>
    <v-row v-if="!progress">
      <v-col>
        <v-card>
          <v-container>
            <v-card-title>
              <h4>{{ this.parent.name.familyName }}</h4>
              <span>　様のご家庭</span>
            </v-card-title>
            <v-card-text>
              <div>
                <span class="grey--text">最寄駅</span>
                <span>　{{ this.parent.nearestStation }}</span>
              </div>
            </v-card-text>
              <v-divider></v-divider>
            <v-card-title>
              <h4>{{ this.student.name.personalName  }}</h4>
              <span>　さん</span>
              </v-card-title>
              <v-card-text>
                {{ this.student.grade().toJapanese()　+ "　"}}
                {{ this.student.genderInJapanese() }}
              </v-card-text>
            <v-card-text>
              <span class="grey--text">指導希望時間帯</span>
            </v-card-text>
            <v-chip
              v-for="schedule in this.student.availableSchedulesToStrings()"
              :key="schedule"
              class="ml-4"
              outlined
            >
              {{ schedule }}
            </v-chip>
            <v-container>
              <v-row justify="end">
                <v-card-actions>
                  <v-btn
                    outlined
                    color="primary"
                    @click="approve"
                  >
                    <v-icon>sentiment_very_satisfied</v-icon>承認
                  </v-btn>
                  <v-btn
                    outlined
                    @click="refuse"
                  >
                    <v-icon>sentiment_very_dissatisfied</v-icon>拒否
                  </v-btn>
                </v-card-actions>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { firestore } from "@/repository/client/firestore.js"
import { RequestRepository } from '@/repository/RequestRepository.js'
import { ParentRepository } from '@/repository/ParentRepository.js'
import { AcceptRequestService } from '@/service/request/accept-request'

export default {
  name: "RequestFromParents",
  props:{
    request: Object,
  },
  data(){
    return {
      teacher: this.$store.getters.teacher,
      student: null,
      parent: null,
      progress: true,
      requestRepo: null,
      parentRepo: null,
    }
  },
  methods:{
    async approve() {
      const service = new AcceptRequestService(firestore, this.teacher)
      this.teacher = await service.execute(this.request.id)
      this.$store.commit("loginAsTeacher", this.teacher)
      this.$emit("removeRequest")
    },
    async refuse() {
      await this.requestRepo.deny(this.request)
      this.$emit("deleteRequest")
    },
  },
  created: async function() {
    const parentRepo = new ParentRepository(firestore)
    this.requestRepo = new RequestRepository(firestore)
    this.parent = await parentRepo.find(this.request.senderId)
    this.student = this.parent.findStudent(this.request.studentId)
    this.progress = false
  },

}

</script>

